module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ovf-hd m-t-20"
  }, [_c('div', {
    staticClass: "fl"
  }, [_vm._v("操作区配置")]), _vm._v(" "), _c('div', {
    staticClass: "fl m-l-20"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addOperation()
      }
    }
  }, [_vm._v("添加")])])]), _vm._v(" "), _c('div', {
    staticClass: "m-t-10"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.componentData,
      "border": "",
      "row-class-name": _vm.tableRowClassName
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "功能点",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("operation")(scope.row.type)) + _vm._s(scope.row.iden))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "关联"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_vm._v(_vm._s(_vm.applicationById))]), _vm._v(" "), (_vm.allOperationById[scope.row.id]) ? _c('span', [_vm._v(_vm._s(_vm.allOperationById[scope.row.id]))]) : _vm._e()]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "位置"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("position")(scope.row.pos)))])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.setConfig(scope.$index, scope.row)
            }
          }
        }, [_vm._v("配置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteOperation(scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60ccad49!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/classify/operationTable.vue
// module id = 1882
// module chunks = 2